import { render, staticRenderFns } from "./imgU.vue?vue&type=template&id=d22e7594"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d22e7594')) {
      api.createRecord('d22e7594', component.options)
    } else {
      api.reload('d22e7594', component.options)
    }
    module.hot.accept("./imgU.vue?vue&type=template&id=d22e7594", function () {
      api.rerender('d22e7594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgU.vue"
export default component.exports